/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserShortInfo} from '../models/UserShortInfo';

export interface GetRecentlyViewedUsers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getRecentlyViewedUsersRequest = createAction<PayloadData<void>>('GET_RECENTLY_VIEWED_USERS__GET_RECENTLY_VIEWED_USERS__REQUEST');
export const getRecentlyViewedUsersSuccess = createAction<PayloadData<Array<UserShortInfo>>>('GET_RECENTLY_VIEWED_USERS__GET_RECENTLY_VIEWED_USERS__SUCCESS');
export const getRecentlyViewedUsersFailure = createAction<PayloadData<Error, void, true>>('GET_RECENTLY_VIEWED_USERS__GET_RECENTLY_VIEWED_USERS__FAILURE');

export const getRecentlyViewedUsersActions = [
    getRecentlyViewedUsersRequest,
    getRecentlyViewedUsersSuccess,
    getRecentlyViewedUsersFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getRecentlyViewedUsers = (config?: GetRecentlyViewedUsers$Config) => {
    return {
        CALL_API: {
            types: getRecentlyViewedUsersActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/recently-viewed`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

